<div class="insurance-list-price" *ngIf="purchasedProduct?.coverage">
    <wuc-price
        *ngIf="purchasedProduct?.coverage?.totalPremiumIncludingDiscount"
        [price]="purchasedProduct?.coverage.totalPremiumIncludingDiscount.premiumIncludingPremiumTax"
        size="l"
    ></wuc-price>
</div>
